import { format } from 'date-fns';

import { ExportResponse } from '~/types/reports';

export function getHeaderString(value: unknown): string | undefined {
  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value) && typeof value[0] === 'string') {
    return value[0];
  }

  return undefined;
}

export function downloadFileFromBlob(
  response: ExportResponse,
  baseFilename: string,
  extension: string = 'xlsx'
): void {
  const nowFormatted = format(new Date(), 'dd-MM-yyyy_HH-mm');
  const filename = `${baseFilename} - ${nowFormatted}.${extension}`;

  const contentDisposition = getHeaderString(
    response.headers['content-disposition']
  );
  let finalFilename = filename;

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    finalFilename = filenameMatch?.[1]?.replace(/['"]/g, '') ?? finalFilename;
  }

  const blob = new Blob([response.data], {
    type: getHeaderString(response.headers['content-type']),
  });

  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = finalFilename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}
